(() => {
  const dialog = document.getElementById('p22-restock-dialog');
  if (!dialog || !window.HTMLDialogElement) return;

  const form = dialog.querySelector('form');
  const email = dialog.querySelector('[name="contact[email]"]');
  const quantity = dialog.querySelector('[name="contact[quantity]"]');
  const fields = dialog.querySelector('[data-p22-restock-fields]');
  const productSummary = dialog.querySelector('[data-p22-restock-product]');
  const productImage = dialog.querySelector('[data-p22-restock-image]');
  const productTitle = dialog.querySelector('[data-p22-restock-product-title]');
  const productLink = dialog.querySelector('[data-p22-restock-product-link]');
  const variantTitle = dialog.querySelector('[data-p22-restock-variant]');
  productImage.addEventListener('error', () => { productImage.hidden = true; });
  const body = dialog.querySelector('[data-p22-restock-body]');
  const imageValue = dialog.querySelector('[data-p22-restock-image-value]');
  let trigger = null;
  let activeProduct = null;
  const storageKey = 'p22-restock-context';

  const safeUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) {
      return '';
    }
  };

  const resetForRequest = () => {
    dialog.querySelectorAll('.p22-restock-dialog__success, .p22-restock-dialog__errors').forEach((element) => {
      element.hidden = true;
    });
    if (fields) fields.hidden = false;
  };

  const showProduct = (data) => {
    activeProduct = data;
    const candidate = safeUrl(data.productUrl);
    const productUrl = candidate && new URL(candidate).origin === location.origin ? candidate : '';
    const imageUrl = safeUrl(data.productImage);
    const variant = data.variantTitle && data.variantTitle !== 'Default Title' ? data.variantTitle : '';

    productTitle.textContent = data.productTitle || 'Requested patch';
    productLink.href = productUrl || '#';
    productLink.hidden = !productUrl;
    variantTitle.textContent = variant ? `Option: ${variant}` : '';
    variantTitle.hidden = !variant;
    productImage.alt = data.productTitle || '';
    if (imageUrl) productImage.src = imageUrl;
    else productImage.removeAttribute('src');
    productImage.hidden = !imageUrl;
    productSummary.hidden = false;

    body.value = [
      'Patch22 restock request',
      `Product: ${data.productTitle || ''}`,
      `Product URL: ${productUrl}`,
      `Product handle: ${data.productHandle || ''}`,
      `Variant: ${variant || (data.variantId ? 'Default style' : 'Not selected; product-level request')}`,
      `Variant ID: ${data.variantId || ''}`,
    ].join('\n');
    imageValue.value = imageUrl;
  };

  const open = (button) => {
    trigger = button;
    resetForRequest();
    showProduct({ ...button.dataset });
    quantity.value = '';
    quantity.setCustomValidity('');
    dialog.showModal();
    email.focus();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-p22-restock]');
    if (!button) return;
    event.preventDefault();
    open(button);
  });

  dialog.querySelector('[data-p22-restock-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => trigger?.focus());

  quantity.addEventListener('input', () => {
    const valid = quantity.value === '' || /^(?:[1-9]\d*)$/.test(quantity.value);
    quantity.setCustomValidity(valid ? '' : 'Enter a whole number of at least 1.');
  });

  form.addEventListener('submit', (event) => {
    quantity.dispatchEvent(new Event('input'));
    if (!form.reportValidity()) { event.preventDefault(); return; }
    try { sessionStorage.setItem(storageKey, JSON.stringify({ product: activeProduct, quantity: quantity.value, created: Date.now() })); } catch (_) {}
    const requestedQuantity = quantity.value ? `Requested quantity: ${quantity.value}` : 'Requested quantity: not specified';
    body.value = `${body.value.replace(/\nRequested quantity:.*$/m, '')}\n${requestedQuantity}`;
  });

  let previous = null;
  try { previous = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
  const returned = location.hash === '#p22-restock-dialog' && previous?.product && Date.now() - previous.created < 3600000;
  if (returned && dialog.querySelector('[data-p22-restock-autopen]')) {
    showProduct(previous.product);
    quantity.value = previous.quantity || '';
    try { sessionStorage.removeItem(storageKey); } catch (_) {}

    dialog.showModal();
    const focusTarget = fields.hidden ? dialog.querySelector('[data-p22-restock-close]') : (fields.querySelector(':invalid') || email);
    focusTarget?.focus();
  }
})();
